import { useTaxCouponUpdateCode } from '@/core/domain/coupon/coupons/coupons.hooks';
import { Button, Upload, message } from 'antd';
import { useInvoiceCFEFormContext } from '../../InvoiceCFEFormProvider';
import { validateCouponReturn } from '@/core/domain/coupon/managerCoupon/managerCoupons.errors';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const InvoiceCFEUpload: React.FC = () => {
  const { taxCoupon } = useInvoiceCFEFormContext();
  const couponUpdateCode = useTaxCouponUpdateCode();

  return (
    <>
      <Upload
        accept="text/plain"
        showUploadList={false}
        customRequest={(opt) => {
          const fr = new FileReader();
          const file = opt.file as File;

          if (file.name) {
            const taxCouponId = file.name.split('_')[0];

            if (!taxCouponId || taxCouponId !== taxCoupon?.id) {
              message.error(
                'Arquivo de retorno importado não contem o mesmo id do cupom',
              );
              !!opt.onError && opt.onError(new Error('Arquivo inválido'));
              return;
            }
          }

          fr.onload = async function () {
            const result = this.result as string;

            if (result) {
              await validateCouponReturn(
                result,
                couponUpdateCode.mutateAsync,
                taxCoupon?.id,
              );
            } else {
              message.error('Arquivo inválido');
              !!opt.onError && opt.onError(new Error('Arquivo inválido'));
            }
          };

          fr.readAsText(opt.file as File);
        }}
      >
        <Button
          type="primary"
          ghost
          disabled={
            !hasPermissions([
              Authorities.FISCAL_COUPON_UPLOAD_DOWNLOAD_SAT_FILE,
            ])
          }
        >
          Upload do arquivo
        </Button>
      </Upload>
    </>
  );
};

export default InvoiceCFEUpload;
